module.exports = {
          srcSet: __webpack_public_path__ + "73cc7cd88328e7a00256a3600313afb4-61.png"+" 61w",
          images:[ {path: __webpack_public_path__ + "73cc7cd88328e7a00256a3600313afb4-61.png",width: 61,height: 42}],
          src: __webpack_public_path__ + "73cc7cd88328e7a00256a3600313afb4-61.png",
          toString:function(){return __webpack_public_path__ + "73cc7cd88328e7a00256a3600313afb4-61.png"},
          
          width: 61,
          height: 42
        }